import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OnBoardingSidebarComponent } from './on-boarding-sidebar.component';
import { SharedModule } from '../../shared.module';
import { MaterialModule } from '../../material.module';
import { FacilityIconModule } from '../facility-icon/facility-icon.module';
import { RouterModule } from '@angular/router';
import { DeviceDetectorModule } from 'ngx-device-detector';



@NgModule({
  declarations: [
    OnBoardingSidebarComponent
  ],
  exports: [
    OnBoardingSidebarComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    MaterialModule,
    FacilityIconModule,
    RouterModule,
    DeviceDetectorModule
  ],
})
export class OnBoardingSidebarModule { }
